import { render, staticRenderFns } from "./ClientOrderDetails.vue?vue&type=template&id=6bfdd6ed&"
import script from "./ClientOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ClientOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ClientOrderDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports